import React from 'react';
import InputMask from 'react-input-mask';

// Source for ZIP mask: https://github.com/sanniassin/react-input-mask (MDR)
// Uses beforeMaskedValueChange to omit trailing minus if it wasn't entered by user

class InputPostCode extends React.Component {
    state = {
        value: ''
    };

    componentDidMount() {
        this.setState({ value: this.props.value });
    }

    onChange = (e) => {
        this.setState({ value: e.target.value }, () => {
            this.props.onChange(this.state.value);
        });
    };
    
    beforeMaskedValueChange = (newState, oldState, userInput) => {
        var { value } = newState;
        var selection = newState.selection;
        var cursorPosition = selection ? selection.start : null;

        // keep minus if entered by user
        if (value.endsWith('-') && userInput !== '-' && !this.state.value.endsWith('-')) {
            if (cursorPosition === value.length) {
                cursorPosition--;
                selection = { start: cursorPosition, end: cursorPosition };
            }
            value = value.slice(0, -1);
        }

        return {
            value,
            selection
        };
    };

    render() {
        let mask = null;
        const val = this.state.value ? this.state.value : "";
        if(val){
            mask = "99999-9999";
        }
        return <InputMask className="form-control" mask={mask} maskChar={null} value={val} onChange={this.onChange} beforeMaskedValueChange={this.beforeMaskedValueChange} required={this.props.required} />;
    }
}

export default InputPostCode;